import React from 'react';
import { FormattedMessage } from 'react-intl';
import { usePciSteps, pciSteps } from '/src/flows/PreCheckIn/pciSteps';
import useInitVisuals from '/src/hooks/useInitVisuals';
import { fsEvents } from '/src/utils/fullstory';
import useAppointmentAndStore from '/src/api/useAppointmentAndStore';
import VehicleCard from '/src/components/VehicleCard/VehicleCard';
import { useMediaQuery } from '/src/utils/mediaQueries/useMediaQueries';
import useAdobePci from '/src/flows/PreCheckIn/v2/common/hooks/useAdobePci';
import trackEvent from '/src/utils/adobe/trackEvent';
import Questions from '/src/flows/PreCheckIn/v2/common/Questions';
import styles from './WelcomePage.module.scss';
import pciCommonStyles from '../common/pciCommon.module.scss';
import RescheduleLink from '/src/flows/PreCheckIn/v2/common/Reschedule';
import useFullstoryPci from '/src/flows/PreCheckIn/v2/common/hooks/useFullstoryPci';

export default () => {
    const { goToNextStep } = usePciSteps();

    const { appointment, isFetchComplete, isDataInvalid, hasFetchedAppointment } =
        useAppointmentAndStore();

    // store is used in tracking but for now is not needed to render the UI:
    useInitVisuals(hasFetchedAppointment);

    const { isDesktop } = useMediaQuery();

    useAdobePci(pciSteps.v2.welcome.name);
    useFullstoryPci(fsEvents.pciWelcome);

    const onClickContinue = () => {
        trackEvent.preCheckin.welcome.click2();
        goToNextStep();
    };

    return (
        isFetchComplete &&
        !isDataInvalid && (
            <div className={pciCommonStyles.pciPageLayout}>
                <hzn-card
                    class={styles.main}
                    border-radius="medium"
                    elevation={isDesktop ? 'none' : 'flat'}
                    padding="medium"
                >
                    <hzn-stack space="large" align-x="center">
                        <hzn-heading as="h1" size="large" align="center">
                            <FormattedMessage id="pci.welcome.heading" />
                            {/* show first name if available: */}
                            {appointment.customerName &&
                                `, ${appointment.customerName.split(' ')[0]}`}
                            ?
                        </hzn-heading>
                        <hzn-text>
                            <FormattedMessage id="pci.welcome.intro" /> {appointment.year}{' '}
                            {appointment.make} {appointment.model}
                        </hzn-text>

                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <VehicleCard {...appointment} />
                        </div>

                        <hzn-text>
                            <FormattedMessage id="pci.welcome.continue" />
                        </hzn-text>
                        <div onClick={onClickContinue} className={styles.ctaContainer}>
                            <hzn-button full-width={isDesktop ? null : true}>
                                <FormattedMessage id="pci.welcome.continueCta" />
                            </hzn-button>
                        </div>

                        <RescheduleLink
                            adobeTracker={trackEvent.preCheckin.welcome.click6}
                            fullstoryPage={fsEvents.pciWelcome}
                        />

                        <Questions
                            eventTrackers={{
                                faq: trackEvent.preCheckin.welcome.click3,
                                phone: trackEvent.preCheckin.welcome.click4,
                                docs: trackEvent.preCheckin.welcome.click5,
                            }}
                        />
                    </hzn-stack>
                </hzn-card>
            </div>
        )
    );
};
